import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import BarTableApi from "api/barTableApi";
import { formatQueryParams } from "helpers/format";

export const getBarTableApi = async (params: any = {}) => {
  try {
    const response = await BarTableApi.barTable(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
};

export const getBarTables = createAsyncThunk("BarTables", getBarTableApi);
export const getWallpapers = createAsyncThunk("Wallpaper", getBarTableApi);
